<template>
  <div class="main" v-bind:class="{ 'subnav-on' : state.api.subnav.length, 'home' : $route.path == '/' }">
    <Nav></Nav>

    <div v-if="state.messages.length">
      <div v-bind:class="['uk-padding-small', 'uk-alert-' + message.class]" v-for="(message, index) in state.messages" uk-alert>
        <a class="uk-alert-close" uk-close @click="state.messages.clearMessage(index)"></a>
        {{message.message}}
      </div>
    </div>

    <router-view v-show="!(state.api.search.active && state.api.search.query)"></router-view>

    <Search v-show="state.api.search.active" />

    <Footer />
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
import Search from './components/Search.vue'

export default {
	inject: [
    'state'
	],
	// data() {
	// 	return {}
	// },
	components: {
		Nav,
		Footer,
    Search
	}
}
</script>
